import { useRef, useEffect } from "react";
import { FestivalEventBannerText, FestivalEventImageBanner } from "./style";
import { useRabbitFestivalContext } from "../../../../hooks/festival-context";

const RabbitFestivalEventBanner = () => {
  const { event, setShowHeader } = useRabbitFestivalContext();
  const bannerRef = useRef<HTMLDivElement>(null);

  // header 투명 여부
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        const target = entries[0];
        if (target.isIntersecting) {
          setShowHeader(true);
        } else {
          setShowHeader(false);
        }
      },
      {
        threshold: 0.5,
      }
    );

    if (bannerRef.current) {
      observer.observe(bannerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, [bannerRef.current]);

  const getDate = () => {
    const start = new Date(event?.tournament.startDate || "");
    const startMonth = start.getMonth() + 1;
    const startDay = start.getDate();

    return `${startMonth}월 ${startDay}일`;
  };

  return (
    <FestivalEventImageBanner ref={bannerRef}>
      <img src={event?.tournament.competition?.bannerImage} alt="banner" />
      <div className="back" />
      <FestivalEventBannerText>
        <div className="address">{event?.tournament.competition?.location}</div>
        <div className="title">
          {event?.tournament.title} <br />
          {event?.tournament.subTitle}
        </div>
        <div className="date">{getDate()}</div>
      </FestivalEventBannerText>
    </FestivalEventImageBanner>
  );
};

export default RabbitFestivalEventBanner;
